import { makeAutoObservable } from "mobx"

import { configApi } from "@src/shared/api"
export interface IConfigResponse {
  payment_page_url?: string
  re_captcha?: {
    /**
     *
     * @type {string}
     * @memberof InlineResponse20015DataReCaptcha
     */
    secret?: string
  }
}
class ConfigStore {
  config: IConfigResponse = {}

  isLoaded = false

  isLoading = true
  load = () => {
    if (this.isLoaded) return Promise.resolve()

    this.isLoading = true

    return configApi
      .config()
      .then(({ data }) => {
        this.config = data.data!

        this.isLoaded = true
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false
      })
  }

  constructor() {
    makeAutoObservable(this)
  }
}

export const configStore = new ConfigStore()
